<div *ngIf="(autoProgress.timer$ | async) > 0" class="m-autoProgressPanel">
  <span class="m-upNextText" i18n="@@PLAYER__PLAY_NEXT">Up next</span>
  <div class="m-autoProgressPanel__container">
    <div
      class="m-autoProgressPanel__left"
      [style.background-image]="
        'url(' + (autoProgress.nextThumbnailSrc$ | async) + ')'
      "
    >
      <i class="material-icons m-autoProgressPanel__playButton">play_arrow</i>
      <div
        id="countdown"
        class="m-progressPanel__countdownContainer"
        (click)="autoProgress.goNext$.next(true)"
      >
        <svg>
          <circle r="20%" cx="50%" cy="40%"></circle>
        </svg>
      </div>

      <span
        class="m-videoPlayer__cancelText"
        (click)="autoProgress.cancel()"
        i18n="@@PLAYER__CANCEL"
        >Cancel</span
      >
    </div>
    <div class="m-autoProgressPanel__right">
      <span class="m-videoPlayer__nextVideoTitle">{{
        autoProgress.nextTitle$ | async
      }}</span>
    </div>
  </div>
</div>
